import React, { useEffect, useState } from "react";

function StudentForms() {
  const [forms, setForms] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("https://wyrowingbackend.onrender.com/student-forms")
      .then((res) => res.json())
      .then((data) => {
        setForms(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error loading student forms:", err);
        setLoading(false);
      });
  }, []);

  const categories = Object.keys(forms).sort((a, b) => a.localeCompare(b));

  return (
<div className="centered-page">
      <h2 style={{ textAlign: "left" }}>Student Forms</h2>
      <p>
        Download and complete the required forms for participation, locate fundraising forms, and find answers to commonly asked rowing/regatta questions. If you have additional questions, please see your coach or contact us at{" "}
        <a href="mailto:friendsofrhsrowing@gmail.com" style={{ color: "rgb(22, 22, 116)" }}>
          friendsofrhsrowing@gmail.com
        </a>
        .
      </p>
      {loading ? (
        <p>Loading student forms...</p>
      ) : categories.length === 0 ? (
        <p>No form categories found.</p>
      ) : (
        categories.map((category) => (
          <div key={category} style={{ marginTop: "2.5rem" }}>
            <h4 style={{ fontWeight: "bold", fontSize: "1.2rem", textAlign: "left" }}>{category}</h4>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th
                    style={{
                      textAlign: "left",
                      borderBottom: "2px solid #000",
                      padding: "0.5rem",
                    }}
                  >
                    Form Name
                  </th>
                </tr>
              </thead>
              <tbody>
                {forms[category].length === 0 ? (
                  <tr>
                    <td colSpan={1} style={{ padding: "0.5rem", color: "#888", textAlign: "left" }}>
                      No forms in this category.
                    </td>
                  </tr>
                ) : (
                  forms[category].map((form, idx) => (
                    <tr key={idx}>
                      <td
                        style={{
                          padding: "0.5rem",
                          borderBottom: "1px solid #ccc",
                          textAlign: "left",
                        }}
                      >
                        <a
                          href={form.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: "rgb(22, 22, 116)",
                            textDecoration: "none",
                          }}
                        >
                          {form.name}
                        </a>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        ))
      )}
    </div>
  );
}

export default StudentForms;